import { Button } from 'react-bootstrap';
import { BsFiletypeCsv, BsThreeDotsVertical } from 'react-icons/bs';

interface ISubRExportReportBtnProps {
  onClick: () => void;
}

const SubRExportReportBtn = ({ onClick }: ISubRExportReportBtnProps) => {
  return (
    <Button variant="primary" size="sm" className="export-button" onClick={onClick}>
      <BsFiletypeCsv size={20} />
      <span>Export</span>
      <BsThreeDotsVertical size={15} />
    </Button>
  );
};

export default SubRExportReportBtn;
